import { IPagination } from 'app/types/common';

export interface IReportsState {
  readonly reportsById?: any;
  readonly reportIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectReportLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddReport?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationReportIds?: string[];
  readonly currentReportId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IReportsSelector extends IReportsState {
  readonly currentReport?: any;
  readonly currentFormReport?: any;
  readonly reportsFilteredByTagInSelectFormat?: any;
  readonly reportsByIdInSelectFormat?: any;
  readonly reportsFilteredByOrganisationInSelectFormat?: any;
}

export enum ReportsActionTypes {
  CREATE_PAYOUT_DETAILED_REPORT_REQUESTED = 'redux-app/reports/CREATE_PAYOUT_DETAILED_REPORT_REQUESTED',
  CREATE_PAYOUT_DETAILED_REPORT_PENDING = 'redux-app/reports/CREATE_PAYOUT_DETAILED_REPORT_PENDING',
  CREATE_PAYOUT_DETAILED_REPORT_SUCCESS = 'redux-app/reports/CREATE_PAYOUT_DETAILED_REPORT_SUCCESS',
  CREATE_PAYOUT_DETAILED_REPORT_FAIL = 'redux-app/reports/CREATE_PAYOUT_DETAILED_REPORT_FAIL',
  CREATE_PAYOUT_SUMMARY_REPORT_REQUESTED = 'redux-app/reports/CREATE_PAYOUT_SUMMARY_REPORT_REQUESTED',
  CREATE_PAYOUT_SUMMARY_REPORT_PENDING = 'redux-app/reports/CREATE_PAYOUT_SUMMARY_REPORT_PENDING',
  CREATE_PAYOUT_SUMMARY_REPORT_SUCCESS = 'redux-app/reports/CREATE_PAYOUT_SUMMARY_REPORT_SUCCESS',
  CREATE_PAYOUT_SUMMARY_REPORT_FAIL = 'redux-app/reports/CREATE_PAYOUT_SUMMARY_REPORT_FAIL',
  CREATE_REFUND_DETAILED_REPORT_REQUESTED = 'redux-app/reports/CREATE_REFUND_DETAILED_REPORT_REQUESTED',
  CREATE_BANK_DEBIT_DETAILED_REPORT_REQUESTED = 'redux-app/reports/CREATE_BANK_DEBIT_DETAILED_REPORT_REQUESTED',
  CREATE_BANK_DEBIT_DETAILED_REPORT_PENDING = 'redux-app/reports/CREATE_BANK_DEBIT_DETAILED_REPORT_PENDING',
  CREATE_BANK_DEBIT_DETAILED_REPORT_SUCCESS = 'redux-app/reports/CREATE_BANK_DEBIT_DETAILED_REPORT_SUCCESS',
  CREATE_BANK_DEBIT_DETAILED_REPORT_FAIL = 'redux-app/reports/CREATE_BANK_DEBIT_DETAILED_REPORT_FAIL',
  CREATE_REFUND_DETAILED_REPORT_PENDING = 'redux-app/reports/CREATE_REFUND_DETAILED_REPORT_PENDING',
  CREATE_REFUND_DETAILED_REPORT_SUCCESS = 'redux-app/reports/CREATE_REFUND_DETAILED_REPORT_SUCCESS',
  CREATE_REFUND_DETAILED_REPORT_FAIL = 'redux-app/reports/CREATE_REFUND_DETAILED_REPORT_FAIL',
  CREATE_MATCH_PAYMENTS_GRID_REPORT_REQUESTED = 'redux-app/reports/CREATE_MATCH_PAYMENTS_GRID_REPORT_REQUESTED',
  CREATE_MATCH_PAYMENTS_GRID_REPORT_PENDING = 'redux-app/reports/CREATE_MATCH_PAYMENTS_GRID_REPORT_PENDING',
  CREATE_MATCH_PAYMENTS_GRID_REPORT_SUCCESS = 'redux-app/reports/CREATE_MATCH_PAYMENTS_GRID_REPORT_SUCCESS',
  CREATE_MATCH_PAYMENTS_GRID_REPORT_FAIL = 'redux-app/reports/CREATE_MATCH_PAYMENTS_GRID_REPORT_FAIL',
  CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_REQUESTED = 'redux-app/reports/CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_REQUESTED',
  CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_PENDING = 'redux-app/reports/CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_PENDING',
  CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_SUCCESS = 'redux-app/reports/CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_SUCCESS',
  CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_FAIL = 'redux-app/reports/CREATE_OVERDUE_MATCH_PAYMENTS_REPORT_FAIL',
  CREATE_TEAM_CONNECTIONS_REPORT_REQUESTED = 'redux-app/reports/CREATE_TEAM_CONNECTIONS_REPORT_REQUESTED',
  CREATE_TEAM_CONNECTIONS_REPORT_PENDING = 'redux-app/reports/CREATE_TEAM_CONNECTIONS_REPORT_PENDING',
  CREATE_TEAM_CONNECTIONS_REPORT_SUCCESS = 'redux-app/reports/CREATE_TEAM_CONNECTIONS_REPORT_SUCCESS',
  CREATE_TEAM_CONNECTIONS_REPORT_FAIL = 'redux-app/reports/CREATE_TEAM_CONNECTIONS_REPORT_FAIL',
}

export default null;
